module.exports = __webpack_public_path__ + "static/media/Mark-Heavy.8676eb9a.ttf";